<template>
    <div class="apprentice-simple-card images-upload">
        <div class="image-upload-header">
            <b-button
                class="btn-upload btn-add-image"
                :disabled="loading"
                variant="primary"
                @click="$refs.fileUpload.click()"
                >{{ $t('images.upload_images') }}
            </b-button>
            <input
                v-show="false"
                v-on:change="uploadFilesChanged"
                ref="fileUpload"
                multiple
                type="file" />
        </div>

        <div
            class="loading"
            v-if="loading">
            <i class="fa fa-spinner fa-spin"></i>
        </div>

        <div
            class="row images-overview"
            v-else>
            <div
                class="col-12 col-sm-6 col-lg-4 col-xl-3 image"
                v-for="image in images">
                <img :src="image.thumb" />
                <div class="description">
                    <div class="title">
                        {{ image.name.split('.').slice(0, -1).join('.') }}
                        <div class="file-size">
                            size
                            <!--                            {{file.file.size}}-->
                        </div>
                    </div>
                    <b-button
                        class="btn-remove btn-remove-image"
                        v-b-tooltip.hover
                        :title="$t('common.delete')"
                        variant="danger-icon-only"
                        @click="onRemove(image.id)">
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-public-image-component',
    props: ['imagesIn', 'categoryIn'],
    data() {
        return {
            images: this.imagesIn,
            category: this.categoryIn,
            category_modal: false,
            form_new: true,
            form: {
                id: '',
                title: '',
            },
            loading: false,
        };
    },
    methods: {
        uploadFilesChanged() {
            this.loading = true;

            const files = this.$refs.fileUpload.files;

            let data = new FormData();
            data.append('category_id', this.category.id);

            let count = 0;
            for (const file of files) {
                data.append('files[' + count + ']', file);
                count++;
            }

            const headers = { 'Content-Type': 'multipart/form-data' };

            this.axios.post('/image/upload', data, { headers: headers }).then(
                (response) => {
                    this.images = response.data;
                    this.loading = false;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onRemove(id) {
            this.alert
                .confirm(this.$t('images.delete_image'), this.$t('images.are_you_sure_you_want_to_delete_this_image'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios.delete('/image/delete/' + id).then(
                            (response) => {
                                this.images = this.images.filter((image) => image.id !== id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        showCreateModal() {
            this.resetForm();
            this.category_modal = true;
        },
        resetForm() {
            this.form.id = '';
            this.form.title = '';
        },
        submitCategory() {
            this.alert.saving();

            if (this.form.id == '') {
                this.axios.post('/image/category/add', this.form).then((response) => {
                    this.category_modal = false;
                    this.resetForm();
                    this.$refs.table.refresh();
                    this.alert.success();
                });
            } else {
                this.axios.post('/image/category/edit', this.form).then((response) => {
                    this.category_modal = false;
                    this.resetForm();
                    this.$refs.table.refresh();
                    this.alert.success();
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.loading {
    display: flex;
    justify-content: center;
    font-size: 2rem;
    color: $primary;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.image-upload-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.image {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    img {
        height: 150px;
        width: 100%;
        object-fit: cover;
        object-position: center;
        border-top-left-radius: $border-radius-content;
        border-top-right-radius: $border-radius-content;
    }

    .description {
        border: 1px solid $border-color;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: baseline;
        border-bottom-left-radius: $border-radius-content;
        border-bottom-right-radius: $border-radius-content;

        .title {
            padding: map-get($grid-gutter-spacing, 'fifteen');
            white-space: normal;
            word-break: break-all;
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
            width: calc(100% - 50px);
            font-weight: $font-weight-bold;
        }
    }
}
</style>
